import script from "./ChooseCustomDashboardModulesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseCustomDashboardModulesDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChooseCustomDashboardModulesDialog.vue?vue&type=style&index=0&id=016bc49b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016bc49b"]])

export default __exports__